import axios from '@axios'

const PREFIX = '/parametrizacao-template'

export default {

  getTemplates(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  salvarTemplate(template) {
    return axios.post(`${PREFIX}/add`, template)
  },

  updateTemplate(id, template) {
    return axios.put(`${PREFIX}/${id}`, template)
  },

  deleteTemplate(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getTemplateById(id) {
    return axios.get(`${PREFIX}/${id}`)
  },
}
